import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ManualBonus from '../../../components/promotions/ManualBonus';

import {
  getExchangeBonuses
} from '@xanadu/ui-shared/modules/promotions/manualBonus/actions';

const mapDispatchToProps = {
  getExchangeBonuses
};


function mapStateToProps(state) {
  return {
    sports: state.getIn(['lookups', 'sports']),
    bonuses: state.getIn(['promotions', 'manualBonus', 'data']),
    loading: state.getIn(['promotions', 'manualBonus', 'loading']),
    error: state.getIn(['promotions', 'manualBonus', 'error']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManualBonus));
